import { Trans } from '@lingui/macro';
import { Icon } from '@economic/taco';

interface Props {
    children: string | JSX.Element;
}

export default function Introduction({ children }: Props) {
    return (
        <>
            <div className="mb-2">{children}</div>
            <div className="text-center mt-4">
                <h2>
                    <Trans>Add Inventory by Rackbeat</Trans>
                </h2>
            </div>
            <div className="mb-4 mt-2">
                <Trans>You are now adding e-conomic's inventory solution, Rackbeat, to your e-conomic agreement.</Trans>
            </div>
            <div className="mb-4 mt-2">
                <Trans>
                    Once you have completed the purchase of Inventory by Rackbeat, you will be redirected to your new inventory
                    solution. It is a standalone system dedicated solely to inventory management and is fully integrated with your
                    accounting.
                </Trans>
            </div>
            <div className="mt-2">
                <h5>
                    <Trans>What happens now?</Trans>
                </h5>
            </div>
            <div
                className="rounded-lg"
                style={{ backgroundColor: '#F6F6F6', padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div className="flex">
                    <span className="mr-2">
                        <Icon name="circle-tick" />
                    </span>
                    <span>
                        <Trans>In just a few steps, you can add Rackbeat Inventory to your agreement</Trans>
                    </span>
                </div>
                <div className="flex">
                    <span className="mr-2">
                        <Icon name="circle-tick" />
                    </span>
                    <span>
                        <Trans>
                            Once the setup is complete, one of our inventory specialists will contact you, to ensure a proper
                            onboarding
                        </Trans>
                    </span>
                </div>
            </div>

            <div className="mt-4 mb-6">
                <Trans>
                    Your products, suppliers, customers and payment terms in e-conomic will be automatically transferred. This
                    integration ensures continuous updates, keeping your inventory synchronized with your accounting.
                </Trans>
            </div>
        </>
    );
}
